import styled from "@emotion/styled";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  List,
  Typography
} from "@mui/material";
import { Component } from "react";
import { withLocale, WithLocaleProps } from "../providers/LocaleProvider";
import { RequestActivityItem } from "./RequestActivityItem";

class RequestActivityFeedBase extends Component<any & WithLocaleProps, any> {
  render() {
    const {
      user,
      employee,
      activity,
      sx,
      onDocumentClick,
      documents,
      style,
      onChecklistClick,
      theme,
      translate
    } = this.props;
    const { documents: feedDocs, latestActivity, previousActivity, checklists } = activity;

    return (
      <Grid className='klayo-feed' sx={sx} item xs={12} md={12} lg={12} style={style ? style : {}}>
        {latestActivity && (
          <StyledAdminFeedbackList>
            <RequestActivityItem
              user={user}
              employee={employee}
              documents={documents ?? feedDocs}
              activity={latestActivity}
              onDocumentClick={onDocumentClick}
              onChecklistClick={onChecklistClick}
              checklists={checklists}
              theme={theme}
            />
          </StyledAdminFeedbackList>
        )}

        {previousActivity && previousActivity.length !== 0 && (
          <Accordion elevation={0}>
            <StyledActivityAccordionSummary
              expandIcon={<ExpandMoreIcon className='klayo-feed_expandicon' />}
              aria-controls='panel1a-content'
              id='panel1a-header'
              sx={{ padding: "16px" }}
            >
              <Typography>{translate("activity.previousActivity")}</Typography>
            </StyledActivityAccordionSummary>
            <AccordionDetails sx={{ padding: "0px" }}>
              <List>
                {previousActivity.map((a: any, i: any) => (
                  <RequestActivityItem
                    key={i}
                    user={user}
                    employee={employee}
                    documents={documents ?? feedDocs}
                    activity={a}
                    onDocumentClick={onDocumentClick}
                    onChecklistClick={onChecklistClick}
                    checklists={checklists}
                    theme={theme}
                  />
                ))}
              </List>
            </AccordionDetails>
          </Accordion>
        )}
      </Grid>
    );
  }
}

export const RequestActivityFeed = withLocale(RequestActivityFeedBase);

const StyledAdminFeedbackList = styled(List)`
  padding: 0px;

  .klayo-feeditem_content {
    margin: 0px;
    padding-top: 0px;
  }
`;

const StyledActivityAccordionSummary = styled(AccordionSummary)`
  padding: 16px;

  .MuiAccordionSummary-content {
    margin: 0px;
  }

  .MuiAccordionSummary-content.Mui-expanded {
    margin: 0px;
  }
`;
